import { Token, User, SelectedTrip } from '@shared/models';
export interface AuthData {
  tokenInfo: Token;
  user: User | null;
  selectedTrip: SelectedTrip | null
}
